import React, { useContext } from "react"
import styled from "styled-components"
import { breakpoints as bp, padding } from "./layout"

import GooglePlayButton from "./forms/googlePlayButton"
import AppStoreButton from "./forms/appStoreButton"
import DevicesButton from "./forms/devicesButton"

interface DownloadButtonsProps {
  key?: string | number
  gtm?: string
  url: string
  content: string
}

const StyledGooglePlayButton = styled(GooglePlayButton)`
  font-size: 1rem;
  height: 48px;
  padding: 4px 20px;
  margin: ${padding.mobile} 0 0 0;
  @media (min-width: ${bp.desktopMin}) {
    margin-bottom: 0;
  }
`

const StyledAppStoreButton = styled(AppStoreButton)`
  font-size: 1rem;
  height: 48px;
  padding: 4px 20px;
  margin: ${padding.mobile} 0 0 0;
  @media (min-width: ${bp.desktopMin}) {
    margin-bottom: 0;
  }
`

const StyledDevicesButton = styled(DevicesButton)`
  font-size: 1rem;
  height: 48px;
  padding: 4px 20px;
  margin: ${padding.mobile} 0 0 0;
  @media (min-width: ${bp.desktopMin}) {
    margin-bottom: 0;
  }
`

export const GooglePlayCta = ({ key, gtm = "#", url, content }: DownloadButtonsProps) => (
  <StyledGooglePlayButton key={key} onClick={() => (window.location.href = url)} data-gtm-cta={gtm}>
    {content}
  </StyledGooglePlayButton>
)

export const AppStoreCta = ({ key, gtm = "#", url, content }: DownloadButtonsProps) => (
  <StyledAppStoreButton key={key} onClick={() => (window.location.href = url)} data-gtm-cta={gtm}>
    {content}
  </StyledAppStoreButton>
)

export const WebStoreCta = ({ key, gtm = "#", url, content }: DownloadButtonsProps) => (
  <StyledDevicesButton key={key} onClick={() => (window.location.href = url)} data-gtm-cta={gtm}>
    {content}
  </StyledDevicesButton>
)
